






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ResponsavelFilial} from '@/model/resource/ResponsavelFilial'
import {InputResponsavelFilialSchema} from '@/schema/resource/ResponsavelFilial/InputResponsavelFilialSchema'

@Component
export default class PersistResponsavelFilialView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelFilialSchema()
  responsavelFilial = new ResponsavelFilial()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.responsavelFilial.getResponsavelFilial(id)
    }

    $.await.done('getResponsavelFilial')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.responsavelFilial.persistResponsavelFilial()
    await Helper.successAndPush(
      'system.success.persist',
      '/responsavel-filial/list'
    )
  }
}
